const winHref = window.location.href
const isSitEnv =
    window.env === 'ALPHA' || winHref.indexOf('127.0.0.1') > -1 || winHref.indexOf('localhost') > -1 || winHref.indexOf('owf.sit.sf-express.com') > -1
const envType = isSitEnv ? 'sit' : 'prod'
// 目前支持的极验验证码的类型
export const captchaType = {
    LOGIN: 'login', // 登录
    QUERY_WAYBILL: 'queryWaybill' // 查单
}

// 极验验证码需要配置多套类型和环境的captchaId
export const captchaEnvId = {
    [captchaType.LOGIN]: {
        sit: 'd3904fa9a9f06085cfb4d4113466d434',
        prod: '38d9e379f9afed8b721d43bfbd6747ca'
    },
    [captchaType.QUERY_WAYBILL]: {
        sit: 'f1f17d80d3a8cbcc7bec2521573f5d4c',
        prod: '7aff034c32dd2092ef63d12b86a95aeb'
    }
}

/**
 * @description 加载极验的验证码
 * @param captchaTypeParam 极验验证码的类型，类型为枚举值captchaType
 * @returns Promise<any>：成功则返回包含信息的result，失败返回null
 */
export const loadGeetestCaptcha = captchaTypeParam =>
    new Promise(resolve => {
        const initGeetest4 = window.initGeetest4
        const params = {
            captchaId: captchaEnvId[captchaTypeParam][envType],
            product: 'bind',
            language: 'zho'
        }
        if (initGeetest4) {
            initGeetest4(params, captcha => {
                resolve(captcha)
            })
        } else {
            try {
                const script = document.createElement('script')
                script.type = 'text/javascript'
                script.src = 'https://static.geetest.com/v4/gt4.js'
                script.defer = true
                document.body.appendChild(script)
                script.onload = () => {
                    window.initGeetest4(params, captcha => {
                        resolve(captcha)
                    })
                }
                script.onerror = () => {
                    console.log('获取验证码js错误')
                    resolve(null)
                }
            } catch (error) {
                console.log(error)
                resolve(null)
            }
        }
    })



// WEBPACK FOOTER //
// ./src/util/load-geetest.js